
const paymentConfirmationStepConfig = {
    
    
    component: () => import('./PaymentConfirmation'),
    flow: 'postBuy',
    hideCartLink: true,
    hidePromoBanner: true
};

export default paymentConfirmationStepConfig;
